(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-noticias"] && !Shopify.designMode) return;
  try {
    
(function() {
  function inicializarNoticias() {
    var secciones = document.querySelectorAll('[data-jq-noticias]');
    secciones.forEach(function(contenedor) {
      if (contenedor.dataset.jqInicializado) return;
      contenedor.dataset.jqInicializado = 'true';

      var disparadores = contenedor.querySelectorAll('[data-jq-toggle]');
      var campoEmail = contenedor.querySelector('#jq-noticias-email');

      disparadores.forEach(function(disparador) {
        disparador.addEventListener('click', function() {
          var abierto = contenedor.classList.toggle('jq-noticias--abierto');
          disparadores.forEach(function(otro) {
            if (otro.hasAttribute('aria-expanded')) {
              otro.setAttribute('aria-expanded', abierto ? 'true' : 'false');
            }
          });
          if (abierto && campoEmail) {
            campoEmail.focus();
          }
        });
      });

      var formulario = contenedor.closest('form');
      var campoTags = contenedor.querySelector('[data-jq-campo-tags]');
      if (formulario && campoTags) {
        formulario.addEventListener('submit', function() {
          var generoSeleccionado = contenedor.querySelector('input[name="jq-noticias-genero"]:checked');
          var etiquetas = 'newsletter';
          if (generoSeleccionado) {
            etiquetas += ',' + generoSeleccionado.value;
          }
          campoTags.value = etiquetas;
        });
      }

      if (contenedor.hasAttribute('data-jq-scroll-aqui')) {
        window.scrollTo(0, 0);
        requestAnimationFrame(function() {
          contenedor.scrollIntoView({ behavior: 'instant', block: 'center' });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicializarNoticias);
  } else {
    inicializarNoticias();
  }

  document.addEventListener('shopify:section:load', inicializarNoticias);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-del-look"] && !Shopify.designMode) return;
  try {
    
(function() {
  function inicializarCarruseles() {
    var carruseles = document.querySelectorAll('[data-jq-carrusel]');
    carruseles.forEach(function(carrusel) {
      if (carrusel.dataset.jqInicializado) return;
      carrusel.dataset.jqInicializado = 'true';

      var pista = carrusel.querySelector('[data-jq-pista]');
      if (!pista) return;

      function obtenerAncho() {
        var primerItem = pista.querySelector('.jq-carrusel-look__item');
        if (!primerItem) return 0;
        var estilos = window.getComputedStyle(pista);
        var gap = parseFloat(estilos.columnGap || estilos.gap || 0);
        return primerItem.getBoundingClientRect().width + gap;
      }

      var arrastrando = false;
      var inicioX = 0;
      var scrollInicial = 0;

      pista.addEventListener('mousedown', function(evento) {
        arrastrando = true;
        pista.classList.add('jq-carrusel-look__pista--arrastrando');
        inicioX = evento.pageX;
        scrollInicial = pista.scrollLeft;
      });

      window.addEventListener('mouseup', function() {
        arrastrando = false;
        pista.classList.remove('jq-carrusel-look__pista--arrastrando');
      });

      window.addEventListener('mouseleave', function() {
        arrastrando = false;
        pista.classList.remove('jq-carrusel-look__pista--arrastrando');
      });

      pista.addEventListener('mousemove', function(evento) {
        if (!arrastrando) return;
        evento.preventDefault();
        var distancia = (evento.pageX - inicioX) * 1.2;
        pista.scrollLeft = scrollInicial - distancia;
      });

      var autoplayActivo = carrusel.dataset.autoplay === 'true';
      var velocidad = parseInt(carrusel.dataset.velocidad, 10) || 3000;
      var temporizador = null;

      function iniciarAutoplay() {
        if (!autoplayActivo) return;
        detenerAutoplay();
        temporizador = setInterval(function() {
          var maximoScroll = pista.scrollWidth - pista.clientWidth;
          if (pista.scrollLeft >= maximoScroll - 2) {
            pista.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            pista.scrollBy({ left: obtenerAncho(), behavior: 'smooth' });
          }
        }, velocidad);
      }

      function detenerAutoplay() {
        if (temporizador) {
          clearInterval(temporizador);
          temporizador = null;
        }
      }

      carrusel.addEventListener('mouseenter', detenerAutoplay);
      carrusel.addEventListener('mouseleave', iniciarAutoplay);
      carrusel.addEventListener('touchstart', detenerAutoplay, { passive: true });

      iniciarAutoplay();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicializarCarruseles);
  } else {
    inicializarCarruseles();
  }

  document.addEventListener('shopify:section:load', inicializarCarruseles);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuadricula-productos"] && !Shopify.designMode) return;
  try {
    
(function() {
  var jqLlaveApertura = String.fromCharCode(123, 123);
  var jqLlaveCierre = String.fromCharCode(125, 125);
  var formatoMoneda = '$' + jqLlaveApertura + 'amount' + jqLlaveCierre;

  function formatearDinero(centavos) {
    var valor = (centavos / 100).toFixed(2);
    var partes = valor.split('.');
    var entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    valor = entero + ',' + partes[1];
    var patronMonto = new RegExp(jqLlaveApertura + '\\s*amount[a-zA-Z_]*\\s*' + jqLlaveCierre);
    return formatoMoneda.replace(patronMonto, valor);
  }

  function obtenerCarrito() {
    return fetch('/cart.js').then(function(respuesta) {
      return respuesta.json();
    });
  }

  function renderizarCarrito(carrito) {
    var contenedorItems = document.querySelector('[data-jq-carrito-items]');
    var subtotal = document.querySelector('[data-jq-carrito-subtotal]');
    if (!contenedorItems || !subtotal) return;

    contenedorItems.innerHTML = '';

    if (!carrito.items.length) {
      contenedorItems.innerHTML = '<p class="jq-cuadricula-producto__carrito-vacio">Tu carrito está vacío</p>';
      subtotal.textContent = formatearDinero(0);
      return;
    }

    carrito.items.forEach(function(articulo) {
      var item = document.createElement('div');
      item.className = 'jq-cuadricula-producto__carrito-item';
      item.innerHTML =
        '<img class="jq-cuadricula-producto__carrito-imagen" src="' + (articulo.image || '') + '" alt="' + articulo.product_title + '">' +
        '<div class="jq-cuadricula-producto__carrito-detalle">' +
        '<p class="jq-cuadricula-producto__carrito-nombre">' + articulo.product_title + '</p>' +
        (articulo.variant_title ? '<p class="jq-cuadricula-producto__carrito-variante">' + articulo.variant_title + '</p>' : '') +
        '<p class="jq-cuadricula-producto__carrito-precio">' + formatearDinero(articulo.final_price) + '</p>' +
        '<div class="jq-cuadricula-producto__carrito-cantidad">' +
        '<button type="button" class="jq-cuadricula-producto__carrito-cantidad-boton" data-jq-restar>−</button>' +
        '<span class="jq-cuadricula-producto__carrito-cantidad-numero">' + articulo.quantity + '</span>' +
        '<button type="button" class="jq-cuadricula-producto__carrito-cantidad-boton" data-jq-sumar>+</button>' +
        '</div>' +
        '<button type="button" class="jq-cuadricula-producto__carrito-eliminar" data-jq-eliminar-item>Eliminar</button>' +
        '</div>';

      item.querySelector('[data-jq-sumar]').addEventListener('click', function() {
        cambiarCantidad(articulo.key, articulo.quantity + 1);
      });
      item.querySelector('[data-jq-restar]').addEventListener('click', function() {
        cambiarCantidad(articulo.key, articulo.quantity - 1);
      });
      item.querySelector('[data-jq-eliminar-item]').addEventListener('click', function() {
        cambiarCantidad(articulo.key, 0);
      });

      contenedorItems.appendChild(item);
    });

    subtotal.textContent = formatearDinero(carrito.total_price);
  }

  function cambiarCantidad(llave, cantidad) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: llave, quantity: cantidad })
    })
      .then(function(respuesta) { return respuesta.json(); })
      .then(function(carrito) {
        renderizarCarrito(carrito);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
  }

  function abrirCarrito() {
    var carrito = document.querySelector('[data-jq-carrito]');
    var fondo = document.querySelector('[data-jq-carrito-fondo]');
    if (!carrito || !fondo) return;
    obtenerCarrito().then(renderizarCarrito);
    carrito.classList.add('jq-cuadricula-producto__carrito--activo');
    fondo.classList.add('jq-cuadricula-producto__carrito-fondo--activo');
  }

  function cerrarCarrito() {
    var carrito = document.querySelector('[data-jq-carrito]');
    var fondo = document.querySelector('[data-jq-carrito-fondo]');
    if (!carrito || !fondo) return;
    carrito.classList.remove('jq-cuadricula-producto__carrito--activo');
    fondo.classList.remove('jq-cuadricula-producto__carrito-fondo--activo');
  }

  function agregarAlCarrito(variantId, boton) {
    if (!variantId) return;
    var textoOriginal = boton.textContent;
    boton.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function(respuesta) {
        if (!respuesta.ok) throw new Error('No se pudo agregar');
        return respuesta.json();
      })
      .then(function() {
        boton.textContent = textoOriginal;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        abrirCarrito();
      })
      .catch(function() {
        boton.textContent = 'Error';
        setTimeout(function() {
          boton.textContent = textoOriginal;
        }, 1500);
      });
  }

  function inicializarCuadricula() {
    var contenedores = document.querySelectorAll('[data-jq-cuadricula]');
    contenedores.forEach(function(contenedor) {
      if (contenedor.dataset.jqInicializado) return;
      contenedor.dataset.jqInicializado = 'true';

      if (contenedor.dataset.moneyFormat) {
        formatoMoneda = contenedor.dataset.moneyFormat;
      }

      contenedor.querySelectorAll('[data-jq-agregar-carrito]').forEach(function(boton) {
        boton.addEventListener('click', function(evento) {
          evento.preventDefault();
          evento.stopPropagation();
          if (boton.disabled) return;
          agregarAlCarrito(boton.dataset.variantId, boton);
        });
      });

      contenedor.querySelectorAll('[data-jq-wishlist]').forEach(function(boton) {
        boton.addEventListener('click', function(evento) {
          evento.preventDefault();
          evento.stopPropagation();
          boton.classList.toggle('jq-cuadricula-producto__wishlist--activo');
        });
      });
    });

    var hoja = document.querySelector('[data-jq-hoja]');
    var hojaFondo = document.querySelector('[data-jq-hoja-fondo]');
    var hojaTitulo = document.querySelector('[data-jq-hoja-titulo]');
    var hojaTallas = document.querySelector('[data-jq-hoja-tallas]');
    var hojaMensaje = document.querySelector('[data-jq-hoja-mensaje]');
    var botonCerrar = document.querySelector('[data-jq-cerrar-hoja]');
    var botonCerrarCarrito = document.querySelector('[data-jq-cerrar-carrito]');
    var carritoFondo = document.querySelector('[data-jq-carrito-fondo]');

    function cerrarHoja() {
      if (!hoja) return;
      hoja.classList.remove('jq-cuadricula-producto__hoja--activa');
      hojaFondo.classList.remove('jq-cuadricula-producto__hoja-fondo--activa');
    }

    function abrirHoja(boton) {
      if (!hoja) return;
      var tarjeta = boton.closest('.jq-cuadricula-producto__tarjeta');
      if (!tarjeta) return;
      var datos = tarjeta.querySelector('[data-jq-datos-talla]');
      hojaTitulo.textContent = boton.dataset.titulo || '';
      hojaTallas.innerHTML = '';
      hojaMensaje.textContent = '';

      if (datos) {
        var valores = datos.querySelectorAll('[data-valor]');
        valores.forEach(function(valor) {
          var elementoBoton = document.createElement('button');
          elementoBoton.type = 'button';
          elementoBoton.className = 'jq-cuadricula-producto__talla-boton';
          elementoBoton.textContent = valor.dataset.valor;
          var disponible = valor.dataset.disponible === 'true';
          if (!disponible) {
            elementoBoton.classList.add('jq-cuadricula-producto__talla-boton--agotada');
            elementoBoton.disabled = true;
          } else {
            elementoBoton.addEventListener('click', function() {
              agregarAlCarritoDesdeHoja(valor.dataset.variantId, elementoBoton);
            });
          }
          hojaTallas.appendChild(elementoBoton);
        });
      }

      hoja.classList.add('jq-cuadricula-producto__hoja--activa');
      hojaFondo.classList.add('jq-cuadricula-producto__hoja-fondo--activa');
    }

    function agregarAlCarritoDesdeHoja(variantId, boton) {
      if (!variantId) return;
      var textoOriginal = boton.textContent;
      boton.textContent = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function(respuesta) {
          if (!respuesta.ok) throw new Error('No se pudo agregar');
          return respuesta.json();
        })
        .then(function() {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          cerrarHoja();
          abrirCarrito();
        })
        .catch(function() {
          boton.textContent = textoOriginal;
          hojaMensaje.textContent = 'No se pudo agregar, intenta de nuevo';
        });
    }

    document.querySelectorAll('[data-jq-abrir-hoja]').forEach(function(boton) {
      if (boton.dataset.jqListo) return;
      boton.dataset.jqListo = 'true';
      boton.addEventListener('click', function(evento) {
        evento.preventDefault();
        evento.stopPropagation();
        abrirHoja(boton);
      });
    });

    if (botonCerrar && !botonCerrar.dataset.jqListo) {
      botonCerrar.dataset.jqListo = 'true';
      botonCerrar.addEventListener('click', cerrarHoja);
    }
    if (hojaFondo && !hojaFondo.dataset.jqListo) {
      hojaFondo.dataset.jqListo = 'true';
      hojaFondo.addEventListener('click', cerrarHoja);
    }
    if (botonCerrarCarrito && !botonCerrarCarrito.dataset.jqListo) {
      botonCerrarCarrito.dataset.jqListo = 'true';
      botonCerrarCarrito.addEventListener('click', cerrarCarrito);
    }
    if (carritoFondo && !carritoFondo.dataset.jqListo) {
      carritoFondo.dataset.jqListo = 'true';
      carritoFondo.addEventListener('click', cerrarCarrito);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicializarCuadricula);
  } else {
    inicializarCuadricula();
  }

  document.addEventListener('shopify:section:load', inicializarCuadricula);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dolce-articulo-editorial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function revelar(raiz) {
      var ambito = raiz || document;
      var secciones = ambito.querySelectorAll ? ambito.querySelectorAll('.da-seccion[data-animar="true"]') : [];
      if (ambito.matches && ambito.matches('.da-seccion[data-animar="true"]')) secciones = [ambito];
      if (window.Shopify && window.Shopify.designMode) {
        Array.prototype.forEach.call(secciones, function (sec) { sec.classList.remove('da-animacion-lista'); });
        return;
      }
      Array.prototype.forEach.call(secciones, function (sec) { sec.classList.add('da-animacion-lista'); });
      var elementos = ambito.querySelectorAll('.da-seccion[data-animar="true"] .da-revelar:not(.da-visible)');
      window.setTimeout(function () {
        Array.prototype.forEach.call(elementos, function (el) { el.classList.add('da-visible'); });
      }, 2500);
      if (!elementos.length) return;
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        elementos.forEach(function (el) { el.classList.add('da-visible'); });
        return;
      }
      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            entrada.target.classList.add('da-visible');
            observador.unobserve(entrada.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      elementos.forEach(function (el) { observador.observe(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { revelar(); });
    } else {
      revelar();
    }

    document.addEventListener('shopify:section:load', function (evento) { revelar(evento.target); });
    document.addEventListener('shopify:block:select', function (evento) {
      var el = evento.target;
      if (el && el.classList) el.classList.add('da-visible');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-dolce"] && !Shopify.designMode) return;
  try {
    
(function() {
  function inicializarFooter() {
    var selectoresPais = document.querySelectorAll('[data-jq-selector-pais]');
    selectoresPais.forEach(function(selector) {
      if (selector.dataset.jqListo) return;
      selector.dataset.jqListo = 'true';
      selector.addEventListener('change', function() {
        selector.closest('form').submit();
      });
    });

    var selectoresIdioma = document.querySelectorAll('[data-jq-selector-idioma]');
    selectoresIdioma.forEach(function(selector) {
      if (selector.dataset.jqListo) return;
      selector.dataset.jqListo = 'true';
      selector.addEventListener('change', function() {
        selector.closest('form').submit();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicializarFooter);
  } else {
    inicializarFooter();
  }

  document.addEventListener('shopify:section:load', inicializarFooter);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitrina-producto"] && !Shopify.designMode) return;
  try {
    
(function() {
  function inicializarVitrinas() {
    var vitrinas = document.querySelectorAll('[data-jq-vitrina]');
    vitrinas.forEach(function(vitrina) {
      if (vitrina.dataset.jqInicializado) return;
      vitrina.dataset.jqInicializado = 'true';

      var pista = vitrina.querySelector('[data-jq-pista]');
      if (pista) {
        var arrastrando = false;
        var inicioX = 0;
        var scrollInicial = 0;

        pista.addEventListener('mousedown', function(evento) {
          arrastrando = true;
          pista.classList.add('jq-vitrina-producto__pista--arrastrando');
          inicioX = evento.pageX;
          scrollInicial = pista.scrollLeft;
        });

        window.addEventListener('mouseup', function() {
          arrastrando = false;
          pista.classList.remove('jq-vitrina-producto__pista--arrastrando');
        });

        window.addEventListener('mouseleave', function() {
          arrastrando = false;
          pista.classList.remove('jq-vitrina-producto__pista--arrastrando');
        });

        pista.addEventListener('mousemove', function(evento) {
          if (!arrastrando) return;
          evento.preventDefault();
          var distancia = (evento.pageX - inicioX) * 1.2;
          pista.scrollLeft = scrollInicial - distancia;
        });
      }

      var botonesWishlist = vitrina.querySelectorAll('[data-jq-wishlist]');
      botonesWishlist.forEach(function(boton) {
        boton.addEventListener('click', function(evento) {
          evento.preventDefault();
          evento.stopPropagation();
          boton.classList.toggle('jq-vitrina-producto__wishlist--activo');
        });
      });

      function cambiarFoto(boton, direccion) {
        var marco = boton.closest('.jq-vitrina-producto__marco');
        if (!marco) return;

        var imagenes = marco.querySelectorAll('.jq-vitrina-producto__imagen');
        if (imagenes.length < 2) return;

        var indiceActual = -1;
        imagenes.forEach(function(imagen, indice) {
          if (imagen.classList.contains('jq-vitrina-producto__imagen--activa')) {
            indiceActual = indice;
          }
        });

        var indiceNuevo = (indiceActual + direccion + imagenes.length) % imagenes.length;

        imagenes.forEach(function(imagen) {
          imagen.classList.remove('jq-vitrina-producto__imagen--activa');
        });
        imagenes[indiceNuevo].classList.add('jq-vitrina-producto__imagen--activa');
      }

      var botonesSiguienteFoto = vitrina.querySelectorAll('[data-jq-siguiente-foto]');
      botonesSiguienteFoto.forEach(function(boton) {
        boton.addEventListener('click', function(evento) {
          evento.preventDefault();
          evento.stopPropagation();
          cambiarFoto(boton, 1);
        });
      });

      var botonesAnteriorFoto = vitrina.querySelectorAll('[data-jq-anterior-foto]');
      botonesAnteriorFoto.forEach(function(boton) {
        boton.addEventListener('click', function(evento) {
          evento.preventDefault();
          evento.stopPropagation();
          cambiarFoto(boton, -1);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicializarVitrinas);
  } else {
    inicializarVitrinas();
  }

  document.addEventListener('shopify:section:load', inicializarVitrinas);
})();

  } catch(e) { console.error(e); }
})();
})();
